// extracted by mini-css-extract-plugin
export var typingIndicator = "_mn-0";